import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../../@types/filter";
import { Paginated } from "../../../../../../@types/paginated";
import { apisiseci } from "../../../../../api";
import { useDefaultSearchParams } from "../../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartmentQueue } from "../../../../../../@types/attendance-local-department-queue";
import { AttendanceLocalDepartmentQueueServiceTime } from "../../../../../../@types/attendance-local-department-queue-service-time";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    fila?: AttendanceLocalDepartmentQueue['id'];
}

export function useAttendanceLocalDepartmentQueueServiceTimeList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    return useQuery<Paginated<AttendanceLocalDepartmentQueueServiceTime>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'department', 'queue', 'service-time', 'list', params],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentQueueServiceTime>>(
                "/cms/tempo_servico_fila/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
